import { render } from "./CasinoGameConfiguration.vue?vue&type=template&id=4656c3d9&scoped=true"
import script from "./CasinoGameConfiguration.vue?vue&type=script&lang=js"
export * from "./CasinoGameConfiguration.vue?vue&type=script&lang=js"

import "./CasinoGameConfiguration.vue?vue&type=style&index=0&id=4656c3d9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4656c3d9"]])

export default __exports__